/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * UserLegacyMetadataDtoBase
 * auto generated base class for the model UserLegacyMetadataDtoModel.
 */
export const UserLegacyMetadataDtoModelBase = ModelBase
  .named('UserLegacyMetadataDto')
  .props({
    __typename: types.optional(types.literal("UserLegacyMetadataDto"), "UserLegacyMetadataDto"),
    uuid: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class UserLegacyMetadataDtoModelSelector extends QueryBuilder {
  get uuid() { return this.__attr(`uuid`) }
}
export function selectFromUserLegacyMetadataDto() {
  return new UserLegacyMetadataDtoModelSelector()
}

export const userLegacyMetadataDtoModelPrimitives = selectFromUserLegacyMetadataDto().uuid
